import React from "react";

const SignalsTabIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M14 12.364C14 13.4685 13.1046 14.364 12 14.364C10.8954 14.364 10 13.4685 10 12.364C10 11.2594 10.8954 10.364 12 10.364C13.1046 10.364 14 11.2594 14 12.364Z"
        fill="#646F87"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.17158 8.12132C9.5621 8.51185 9.5621 9.14501 9.17157 9.53554C8.80014 9.90697 8.5055 10.3479 8.30448 10.8332C8.10346 11.3185 8 11.8387 8 12.364C8 12.8893 8.10346 13.4094 8.30448 13.8947C8.5055 14.38 8.80014 14.821 9.17157 15.1924C9.5621 15.5829 9.5621 16.2161 9.17157 16.6066C8.78105 16.9971 8.14788 16.9971 7.75736 16.6066C7.20021 16.0495 6.75825 15.388 6.45672 14.6601C6.15519 13.9321 6 13.1519 6 12.364C6 11.576 6.1552 10.7958 6.45672 10.0679C6.75825 9.33991 7.20021 8.67847 7.75736 8.12132C8.14789 7.7308 8.78105 7.7308 9.17158 8.12132Z"
        fill="#646F87"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.34315 5.29289C6.73367 5.68342 6.73367 6.31658 6.34315 6.70711C4.84285 8.2074 4 10.2422 4 12.364C4 14.4857 4.84285 16.5205 6.34315 18.0208C6.73367 18.4113 6.73367 19.0445 6.34315 19.435C5.95262 19.8256 5.31946 19.8256 4.92893 19.435C3.05357 17.5597 2 15.0161 2 12.364C2 9.7118 3.05357 7.16826 4.92893 5.29289C5.31946 4.90237 5.95262 4.90237 6.34315 5.29289Z"
        fill="#646F87"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8284 8.12132C14.4379 8.51185 14.4379 9.14501 14.8284 9.53554C15.1999 9.90697 15.4945 10.3479 15.6955 10.8332C15.8965 11.3185 16 11.8387 16 12.364C16 12.8893 15.8965 13.4094 15.6955 13.8947C15.4945 14.38 15.1999 14.821 14.8284 15.1924C14.4379 15.5829 14.4379 16.2161 14.8284 16.6066C15.219 16.9971 15.8521 16.9971 16.2426 16.6066C16.7998 16.0495 17.2417 15.388 17.5433 14.6601C17.8448 13.9321 18 13.1519 18 12.364C18 11.576 17.8448 10.7958 17.5433 10.0679C17.2417 9.33991 16.7998 8.67847 16.2426 8.12132C15.8521 7.7308 15.2189 7.7308 14.8284 8.12132Z"
        fill="#646F87"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6569 5.29289C17.2663 5.68342 17.2663 6.31658 17.6569 6.70711C19.1571 8.2074 20 10.2422 20 12.364C20 14.4857 19.1571 16.5205 17.6569 18.0208C17.2663 18.4113 17.2663 19.0445 17.6569 19.435C18.0474 19.8256 18.6805 19.8256 19.0711 19.435C20.9464 17.5597 22 15.0161 22 12.364C22 9.7118 20.9464 7.16826 19.0711 5.29289C18.6805 4.90237 18.0474 4.90237 17.6569 5.29289Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default SignalsTabIcon;
